/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react'

export default function Maps({long,lat}) {
  return (
    <div className="wrapperMap rounded-2xl">
      <iframe
        src={`https://maps.google.com/maps?q=${lat},${long}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
        width="800"
        height="650"
        className="border rounded-2xl border-secondary"
        // style={{border:0,borderRadius: '16px'}}
        allowFullScreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
